/**
 * @class ApiClientConsts - constants for api client
 */
export class ApiClientConsts {
    /**
     * @property ContentTypeJson - json content type name
     */
    static get ContentTypeJson(): string {
        return 'application/json';
    }

    /**
     * @property HttpMethod - supported http methods
     */
    static get HttpMethod() {
        return {
            POST: 'POST',
            GET: 'GET'
        }
    }

    /**
     * @property HeaderNames - http header names constants
     */
    static get HeaderNames() {
        return {
            WWWAuthenticate: 'www-authenticate'
        }
    }

    /**
     * @property HeaderValues - http header values constants
     */
    static get HeaderValues() {
        return {
            token: 'token'
        }
    }

    /**
     * @property AuthenticationScheme - http authentication scheme name
     */
    static get AuthenticationScheme(): string {
        return 'Bearer';
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/ApiClientConsts.ts
 **/